/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=2393fd04"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2393fd04&lang=less"

import exportComponent from "D:\\HBuilderProjects\\quyizu-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__